module.exports = __webpack_public_path__ + "img/net_banner_white_600.d039be33.png";